<template functional>
  <vx-card
    class="overflow-hidden"
    style="min-height: 180px;"
    >
    <template slot="no-body">
      <div class="p-6 flex flex-row justify-start items-center">

        <feather-icon icon="UsersIcon"
          class="p-3 mr-4 w-12 h-12 inline-flex rounded-full text-primary"
          :style="{ background: `rgba(var(--vs-primary),.15)` }"
        />

        <div class="truncate">
          <div v-if="props.updating">
            <span class="text-primary">{{ parent.$t('stats.total-student-counting') }}</span>
            <h2 class="mb-1 font-semibold text-primary">-</h2>
          </div>
          <div v-else>
            <span class="text-primary">{{ parent.$t('stats.total-student') }}</span>
            <h2 class="mb-1 font-semibold text-primary">{{ props.total }}</h2>
          </div>
        </div>
        
      </div>

      <!-- Loader -->
      <div class="loader w-full">
        <component v-if="props.updating" :is="injections.components.Loader" small />
      </div>

      <div class="line-area-chart">
        <component :is="injections.components.VueApexCharts"
          type="area" height=100 width='100%'
          :series="props.chartSeries"
          :options="props.chartOptions" />
      </div>

    </template>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Loader from "@/components/common-ui/loader-block";

export default {
  inject: {
    components: {
      default: {
        VueApexCharts,
        Loader
      }
    }
  },
  props: {
    updating: {
      type: Boolean, default: true
    },
    total: {
      type: Number, default: 0
    },
    chartOptions: {
      type: Object, default: null,
    },
    chartSeries: {
      type: Array, default: null
    }
  }
}
</script>

<style lang="scss">
.loader {
  // width: 120px;
  min-height: 200px;
  height: 100%;
  position: absolute;
  top: 0;
  margin: 8px auto;
  transition: all 0.3s ease;
  cursor: pointer;
  z-index: 39999;
  
  h4 {
    z-index: 40000;
    position: relative;
    text-align: center;
    padding: 10px;
  }
}
</style>
